(() => {
  if (!document.querySelectorAll('.x-header-cart').length) return;

  let revision = 0;
  const isValidCount = (count) => Number.isInteger(count) && count >= 0;

  function renderCount(count) {
    const countLabel = count === 1 ? window.cartStrings.countOne : window.cartStrings.countOther;
    document.querySelectorAll('.x-header-cart').forEach((link) => {
      link.setAttribute('aria-label', `${window.cartStrings.cartLabel}: ${countLabel.replace('[count]', count)}`);
      let badge = link.querySelector('.x-header-cart__count');
      if (count === 0) {
        if (badge) badge.remove();
        return;
      }
      if (!badge) {
        badge = document.createElement('span');
        link.append(badge);
      }
      const size = count < 10 ? 'small' : count < 100 ? 'medium' : 'max';
      badge.className = `x-header-cart__count x-header-cart__count--${size}`;
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.setAttribute('aria-hidden', 'true');
    });
  }

  async function syncCount(cartData) {
    // Ignore older reads that finish after a more recent cart update.
    const currentRevision = ++revision;
    try {
      if (isValidCount(cartData?.item_count)) {
        renderCount(cartData.item_count);
        return;
      }
      // add.js returns the added line, not the total quantity of the cart.
      const response = await fetch(`${window.routes.cart_url}.js`, {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      });
      if (!response.ok) throw new Error(`Cart count request failed: ${response.status}`);
      const cart = await response.json();
      if (!isValidCount(cart.item_count)) throw new Error('Invalid cart item count');
      if (currentRevision === revision) renderCount(cart.item_count);
    } catch (error) {
      // Keep the last known count; a refresh failure does not undo a successful add.
      console.error('Unable to sync header cart count', error);
    }
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => syncCount(event.cartData));
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) return syncCount();
  });
  syncCount();
})();
